import { render, staticRenderFns } from "./NoNextPeriodBox.vue?vue&type=template&id=82465c70&"
import script from "./NoNextPeriodBox.vue?vue&type=script&lang=js&"
export * from "./NoNextPeriodBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports